/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 4ClPPEaVaNLI

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import HeaderMenuItem from "../../HeaderMenuItem"; // plasmic-import: YACCL_iSDMYi/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import MobileDrawer from "../../MobileDrawer"; // plasmic-import: 3Gf4zc1YpP_7/component
import MobileDrawerItem from "../../MobileDrawerItem"; // plasmic-import: Kb3kPKRcQbBm/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHeader.module.css"; // plasmic-import: 4ClPPEaVaNLI/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon
import Icon3Icon from "./icons/PlasmicIcon__Icon3"; // plasmic-import: ASrk5vWaGnLc/icon

createPlasmicElementProxy;

export type PlasmicHeader__VariantMembers = {
  color: "transparent" | "white";
};
export type PlasmicHeader__VariantsArgs = {
  color?: SingleChoiceArg<"transparent" | "white">;
};
type VariantPropType = keyof PlasmicHeader__VariantsArgs;
export const PlasmicHeader__VariantProps = new Array<VariantPropType>("color");

export type PlasmicHeader__ArgsType = {
  onContactClick?: () => void;
  currentPage?: string;
};
type ArgPropType = keyof PlasmicHeader__ArgsType;
export const PlasmicHeader__ArgProps = new Array<ArgPropType>(
  "onContactClick",
  "currentPage"
);

export type PlasmicHeader__OverridesType = {
  root?: Flex__<"header">;
  desktopHeader?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  logo?: Flex__<"a"> & Partial<LinkProps>;
  navWrapper?: Flex__<"div">;
  nav?: Flex__<"nav">;
  features?: Flex__<typeof HeaderMenuItem>;
  actions?: Flex__<"div">;
  logInButton?: Flex__<typeof Button>;
  requestDemoButton?: Flex__<typeof Button>;
  mobileHeader2?: Flex__<"div">;
  logo3?: Flex__<"a"> & Partial<LinkProps>;
  right2?: Flex__<"div">;
  logInLink?: Flex__<"a"> & Partial<LinkProps>;
  divider?: Flex__<"div">;
  mobileDrawer?: Flex__<typeof MobileDrawer>;
  button?: Flex__<"button">;
  hamburgerIcon?: Flex__<"svg">;
  body?: Flex__<"div">;
  menu?: Flex__<"nav">;
  mobileDrawerItem?: Flex__<typeof MobileDrawerItem>;
  bottom?: Flex__<"div">;
  actions2?: Flex__<"div">;
  requestDemoButton2?: Flex__<typeof Button>;
  logInButton2?: Flex__<typeof Button>;
  socials?: Flex__<"div">;
  x?: Flex__<"a"> & Partial<LinkProps>;
  fb?: Flex__<"a"> & Partial<LinkProps>;
  ig?: Flex__<"a"> & Partial<LinkProps>;
  li?: Flex__<"a"> & Partial<LinkProps>;
  th?: Flex__<"a"> & Partial<LinkProps>;
};

export interface DefaultHeaderProps {
  onContactClick?: () => void;
  currentPage?: string;
  color?: SingleChoiceArg<"transparent" | "white">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHeader__RenderFunc(props: {
  variants: PlasmicHeader__VariantsArgs;
  args: PlasmicHeader__ArgsType;
  overrides: PlasmicHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          currentPage: "/"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "mobileDrawer.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          hasVariant(globalVariants, "mobile", "mobile") ? false : false
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <header
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_transparent]: hasVariant(
            $state,
            "color",
            "transparent"
          ),
          [sty.rootcolor_white]: hasVariant($state, "color", "white")
        }
      )}
    >
      <div
        data-plasmic-name={"desktopHeader"}
        data-plasmic-override={overrides.desktopHeader}
        className={classNames("all", sty.desktopHeader, {
          [sty.desktopHeadercolor_transparent]: hasVariant(
            $state,
            "color",
            "transparent"
          ),
          [sty.desktopHeadercolor_white]: hasVariant($state, "color", "white")
        })}
      >
        <div
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}
          className={classNames("all", sty.wrapper)}
        >
          <PlasmicLink__
            data-plasmic-name={"logo"}
            data-plasmic-override={overrides.logo}
            aria-label={"Home"}
            className={classNames("all", "a", "a__bvRZj", sty.logo)}
            component={Link}
            href={`/`}
            legacyBehavior={false}
            platform={"nextjs"}
            title={"Home"}
          >
            <PlasmicImg__
              alt={"MyEvaluations logo"}
              className={classNames(sty.img__mneaK)}
              displayHeight={"26.52px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"151.7px"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/47bb5f20d61d9136c9ee5c2f48079ac6.svg",
                fullWidth: 151.703,
                fullHeight: 26.517,
                aspectRatio: 5.62963
              }}
            />
          </PlasmicLink__>
          <div
            data-plasmic-name={"navWrapper"}
            data-plasmic-override={overrides.navWrapper}
            className={classNames("all", sty.navWrapper)}
          >
            <nav
              data-plasmic-name={"nav"}
              data-plasmic-override={overrides.nav}
              className={classNames("all", sty.nav)}
            >
              {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                (() => {
                  try {
                    return [
                      {
                        name: "Features",
                        link: "/features"
                      },
                      {
                        name: "Capabilities",
                        link: "/Capabilities"
                      },
                      {
                        name: "Pricing",
                        link: "/pricing"
                      },
                      {
                        name: "Contact",
                        link: "/contact"
                      }
                    ];
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return [];
                    }
                    throw e;
                  }
                })()
              ).map((__plasmic_item_0, __plasmic_idx_0) => {
                const currentItem = __plasmic_item_0;
                const currentIndex = __plasmic_idx_0;
                return (
                  <HeaderMenuItem
                    data-plasmic-name={"features"}
                    data-plasmic-override={overrides.features}
                    active={(() => {
                      try {
                        return $props.currentPage === currentItem.link;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()}
                    className={classNames("__wab_instance", sty.features)}
                    key={currentIndex}
                    link={(() => {
                      try {
                        return currentItem.link === "/contact"
                          ? null
                          : currentItem.link;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return undefined;
                        }
                        throw e;
                      }
                    })()}
                    name={(() => {
                      try {
                        return currentItem.name;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return undefined;
                        }
                        throw e;
                      }
                    })()}
                    onClick={async () => {
                      const $steps = {};

                      $steps["runOnContactClick"] =
                        currentItem.link === "/contact"
                          ? (() => {
                              const actionArgs = {
                                eventRef: $props["onContactClick"]
                              };
                              return (({ eventRef, args }) => {
                                return eventRef?.(...(args ?? []));
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                      if (
                        $steps["runOnContactClick"] != null &&
                        typeof $steps["runOnContactClick"] === "object" &&
                        typeof $steps["runOnContactClick"].then === "function"
                      ) {
                        $steps["runOnContactClick"] =
                          await $steps["runOnContactClick"];
                      }
                    }}
                  />
                );
              })}
            </nav>
          </div>
          <div
            data-plasmic-name={"actions"}
            data-plasmic-override={overrides.actions}
            className={classNames("all", sty.actions)}
          >
            <Button
              data-plasmic-name={"logInButton"}
              data-plasmic-override={overrides.logInButton}
              aria-label={"Log in"}
              className={classNames("__wab_instance", sty.logInButton, {
                [sty.logInButtoncolor_white]: hasVariant(
                  $state,
                  "color",
                  "white"
                )
              })}
              color={"white"}
              link={`/login`}
              size={"small"}
            >
              <div className={classNames("all", "__wab_text", sty.text__sduxe)}>
                {"Log in"}
              </div>
            </Button>
            <Button
              data-plasmic-name={"requestDemoButton"}
              data-plasmic-override={overrides.requestDemoButton}
              aria-label={"Request demo"}
              className={classNames("__wab_instance", sty.requestDemoButton, {
                [sty.requestDemoButtoncolor_white]: hasVariant(
                  $state,
                  "color",
                  "white"
                )
              })}
              color={"primary"}
              link={
                "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
              }
              size={"small"}
              target={true}
            >
              <div className={classNames("all", "__wab_text", sty.text__aprEt)}>
                {"Request demo"}
              </div>
            </Button>
          </div>
        </div>
      </div>
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? true
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : hasVariant(globalVariants, "mobile", "tabletLandscape")
              ? true
              : false
      ) ? (
        <div
          data-plasmic-name={"mobileHeader2"}
          data-plasmic-override={overrides.mobileHeader2}
          className={classNames("all", sty.mobileHeader2, {
            [sty.mobileHeader2color_transparent]: hasVariant(
              $state,
              "color",
              "transparent"
            ),
            [sty.mobileHeader2color_white]: hasVariant($state, "color", "white")
          })}
        >
          <PlasmicLink__
            data-plasmic-name={"logo3"}
            data-plasmic-override={overrides.logo3}
            aria-label={"Home"}
            className={classNames("all", "a", "a__bvRZj", sty.logo3, {
              [sty.logo3color_transparent]: hasVariant(
                $state,
                "color",
                "transparent"
              )
            })}
            component={Link}
            href={`/`}
            legacyBehavior={false}
            platform={"nextjs"}
            title={"Home"}
          >
            <PlasmicImg__
              alt={"MyEvaluations logo"}
              className={classNames(sty.img__rhiFu)}
              displayHeight={"29.83px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"170.67px"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/f7a2645d1f520625588f9e3581d30856.svg",
                fullWidth: 170.666,
                fullHeight: 29.831,
                aspectRatio: 5.7
              }}
            />
          </PlasmicLink__>
          <div
            data-plasmic-name={"right2"}
            data-plasmic-override={overrides.right2}
            className={classNames("all", sty.right2, {
              [sty.right2color_transparent]: hasVariant(
                $state,
                "color",
                "transparent"
              )
            })}
          >
            {(
              hasVariant(globalVariants, "mobile", "mobileXSmall")
                ? false
                : true
            ) ? (
              <PlasmicLink__
                data-plasmic-name={"logInLink"}
                data-plasmic-override={overrides.logInLink}
                aria-label={"Log in"}
                className={classNames(
                  "all",
                  "a",
                  "a__bvRZj",
                  "__wab_text",
                  sty.logInLink
                )}
                component={Link}
                href={`/login`}
                legacyBehavior={false}
                platform={"nextjs"}
                title={"Log in"}
              >
                {"Log In"}
              </PlasmicLink__>
            ) : null}
            {(
              hasVariant(globalVariants, "mobile", "mobileXSmall")
                ? false
                : hasVariant(globalVariants, "mobile", "mobile")
                  ? true
                  : true
            ) ? (
              <div
                data-plasmic-name={"divider"}
                data-plasmic-override={overrides.divider}
                className={classNames("all", sty.divider)}
              />
            ) : null}
            <MobileDrawer
              data-plasmic-name={"mobileDrawer"}
              data-plasmic-override={overrides.mobileDrawer}
              className={classNames("__wab_instance", sty.mobileDrawer)}
              dialogBody={
                <div
                  data-plasmic-name={"body"}
                  data-plasmic-override={overrides.body}
                  className={classNames("all", sty.body)}
                >
                  <nav
                    data-plasmic-name={"menu"}
                    data-plasmic-override={overrides.menu}
                    className={classNames("all", sty.menu)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              name: "Home",
                              link: "/m"
                            },
                            {
                              name: "Features",
                              link: "/features"
                            },
                            {
                              name: "Capabilities",
                              link: "/Capabilities"
                            },
                            {
                              name: "Pricing",
                              link: "/pricing"
                            },
                            {
                              name: "Contact",
                              link: "/contact"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <MobileDrawerItem
                          data-plasmic-name={"mobileDrawerItem"}
                          data-plasmic-override={overrides.mobileDrawerItem}
                          active={(() => {
                            try {
                              return $props.currentPage === currentItem.link;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()}
                          className={classNames(
                            "__wab_instance",
                            sty.mobileDrawerItem
                          )}
                          item={(() => {
                            try {
                              return currentItem;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          key={currentIndex}
                          onContactClick={async () => {
                            const $steps = {};

                            $steps["runOnContactClick"] = true
                              ? (() => {
                                  const actionArgs = {
                                    eventRef: $props["onContactClick"]
                                  };
                                  return (({ eventRef, args }) => {
                                    return eventRef?.(...(args ?? []));
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["runOnContactClick"] != null &&
                              typeof $steps["runOnContactClick"] === "object" &&
                              typeof $steps["runOnContactClick"].then ===
                                "function"
                            ) {
                              $steps["runOnContactClick"] =
                                await $steps["runOnContactClick"];
                            }
                          }}
                          withAccordion={(() => {
                            try {
                              return currentItem.subitems.length > 0;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()}
                        />
                      );
                    })}
                  </nav>
                  <div
                    data-plasmic-name={"bottom"}
                    data-plasmic-override={overrides.bottom}
                    className={classNames("all", sty.bottom)}
                  >
                    <div
                      data-plasmic-name={"actions2"}
                      data-plasmic-override={overrides.actions2}
                      className={classNames("all", sty.actions2)}
                    >
                      <Button
                        data-plasmic-name={"requestDemoButton2"}
                        data-plasmic-override={overrides.requestDemoButton2}
                        aria-label={"Request demo"}
                        className={classNames(
                          "__wab_instance",
                          sty.requestDemoButton2
                        )}
                        color={"primary"}
                        link={
                          "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                        }
                        size={"large"}
                        target={true}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__hHXu6
                          )}
                        >
                          {"Request demo"}
                        </div>
                      </Button>
                      <Button
                        data-plasmic-name={"logInButton2"}
                        data-plasmic-override={overrides.logInButton2}
                        aria-label={"Log in"}
                        className={classNames(
                          "__wab_instance",
                          sty.logInButton2
                        )}
                        color={"sky"}
                        link={`/login`}
                        size={"large"}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__jsmib
                          )}
                        >
                          {"Log in"}
                        </div>
                      </Button>
                    </div>
                    <div
                      data-plasmic-name={"socials"}
                      data-plasmic-override={overrides.socials}
                      className={classNames("all", sty.socials)}
                    >
                      <PlasmicLink__
                        data-plasmic-name={"x"}
                        data-plasmic-override={overrides.x}
                        aria-label={"Open MyEvaluations X page"}
                        className={classNames("all", "a", "a__bvRZj", sty.x)}
                        component={Link}
                        href={"https://twitter.com/myevaluations/media"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                        target={"_blank"}
                        title={"Open MyEvaluations X page"}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__zRi8V)}
                          displayHeight={"32px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"32px"}
                          loader={"plasmic"}
                          loading={"lazy"}
                          src={{
                            src: "https://site-assets.plasmic.app/5c16cc6098d8223f6ee21c936cbdbc43.svg",
                            fullWidth: 24,
                            fullHeight: 24,
                            aspectRatio: 1
                          }}
                        />
                      </PlasmicLink__>
                      <PlasmicLink__
                        data-plasmic-name={"fb"}
                        data-plasmic-override={overrides.fb}
                        aria-label={"Open MyEvaluations Facebook page"}
                        className={classNames("all", "a", "a__bvRZj", sty.fb)}
                        component={Link}
                        href={"https://web.facebook.com/myevaluations"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                        target={"_blank"}
                        title={"Open MyEvaluations Facebook page"}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__dvDxu)}
                          displayHeight={"32px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"32px"}
                          loader={"plasmic"}
                          loading={"lazy"}
                          src={{
                            src: "https://site-assets.plasmic.app/24dbb12092ac2a0b739d01ca30614897.svg",
                            fullWidth: 24,
                            fullHeight: 24,
                            aspectRatio: 1
                          }}
                        />
                      </PlasmicLink__>
                      <PlasmicLink__
                        data-plasmic-name={"ig"}
                        data-plasmic-override={overrides.ig}
                        aria-label={"Open MyEvaluations Instagram page"}
                        className={classNames("all", "a", "a__bvRZj", sty.ig)}
                        component={Link}
                        href={"https://www.instagram.com/myevaluations/"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                        target={"_blank"}
                        title={"Open MyEvaluations Instagram page"}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__s9WzT)}
                          displayHeight={"32px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"32px"}
                          loader={"plasmic"}
                          loading={"lazy"}
                          src={{
                            src: "https://site-assets.plasmic.app/bdd639079ea2546ece1ab194ad192475.svg",
                            fullWidth: 24,
                            fullHeight: 24,
                            aspectRatio: 1
                          }}
                        />
                      </PlasmicLink__>
                      <PlasmicLink__
                        data-plasmic-name={"li"}
                        data-plasmic-override={overrides.li}
                        aria-label={"Open MyEvaluations LinkedIn page"}
                        className={classNames("all", "a", "a__bvRZj", sty.li)}
                        component={Link}
                        href={
                          "https://www.linkedin.com/company/myevaluations.com-inc/?viewAsMember=true"
                        }
                        legacyBehavior={false}
                        platform={"nextjs"}
                        title={"Open MyEvaluations LinkedIn page"}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__oSjo3)}
                          displayHeight={"32px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"32px"}
                          loader={"plasmic"}
                          loading={"lazy"}
                          src={{
                            src: "https://site-assets.plasmic.app/1542355768a34cbafbf427680e35942f.svg",
                            fullWidth: 24,
                            fullHeight: 24,
                            aspectRatio: 1
                          }}
                        />
                      </PlasmicLink__>
                      <PlasmicLink__
                        data-plasmic-name={"th"}
                        data-plasmic-override={overrides.th}
                        aria-label={"Open MyEvaluations Threads page"}
                        className={classNames("all", "a", "a__bvRZj", sty.th)}
                        component={Link}
                        href={"https://www.threads.net/@myevaluations"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                        target={"_blank"}
                        title={"Open MyEvaluations Threads page"}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__pKpQ7)}
                          displayHeight={"32px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"32px"}
                          loader={"plasmic"}
                          loading={"lazy"}
                          onClick={async event => {
                            const $steps = {};

                            $steps["goToPage"] = true
                              ? (() => {
                                  const actionArgs = { destination: "" };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      __nextRouter?.push(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToPage"] != null &&
                              typeof $steps["goToPage"] === "object" &&
                              typeof $steps["goToPage"].then === "function"
                            ) {
                              $steps["goToPage"] = await $steps["goToPage"];
                            }
                          }}
                          src={{
                            src: "https://site-assets.plasmic.app/0c6bcef4caa3daf40c5ce4a872fcc13b.svg",
                            fullWidth: 24,
                            fullHeight: 24,
                            aspectRatio: 1
                          }}
                        />
                      </PlasmicLink__>
                    </div>
                  </div>
                </div>
              }
              onContactClick={async () => {
                const $steps = {};

                $steps["runOnContactClick"] = true
                  ? (() => {
                      const actionArgs = { eventRef: $props["onContactClick"] };
                      return (({ eventRef, args }) => {
                        return eventRef?.(...(args ?? []));
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runOnContactClick"] != null &&
                  typeof $steps["runOnContactClick"] === "object" &&
                  typeof $steps["runOnContactClick"].then === "function"
                ) {
                  $steps["runOnContactClick"] =
                    await $steps["runOnContactClick"];
                }
              }}
              onOpenChange={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "mobileDrawer",
                  "open"
                ]).apply(null, eventArgs);

                if (
                  eventArgs.length > 1 &&
                  eventArgs[1] &&
                  eventArgs[1]._plasmic_state_init_
                ) {
                  return;
                }
              }}
              open={generateStateValueProp($state, ["mobileDrawer", "open"])}
              trigger={
                <button
                  data-plasmic-name={"button"}
                  data-plasmic-override={overrides.button}
                  aria-label={"Open drawer"}
                  className={classNames(
                    "all",
                    "button",
                    "button__bvRZj",
                    sty.button
                  )}
                  title={"Open drawer"}
                >
                  <Icon3Icon
                    data-plasmic-name={"hamburgerIcon"}
                    data-plasmic-override={overrides.hamburgerIcon}
                    aria-label={
                      hasVariant(globalVariants, "mobile", "mobile")
                        ? "Open drawer"
                        : "Open"
                    }
                    className={classNames("all", sty.hamburgerIcon)}
                    role={"img"}
                  />
                </button>
              }
            />
          </div>
        </div>
      ) : null}
    </header>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "desktopHeader",
    "wrapper",
    "logo",
    "navWrapper",
    "nav",
    "features",
    "actions",
    "logInButton",
    "requestDemoButton",
    "mobileHeader2",
    "logo3",
    "right2",
    "logInLink",
    "divider",
    "mobileDrawer",
    "button",
    "hamburgerIcon",
    "body",
    "menu",
    "mobileDrawerItem",
    "bottom",
    "actions2",
    "requestDemoButton2",
    "logInButton2",
    "socials",
    "x",
    "fb",
    "ig",
    "li",
    "th"
  ],
  desktopHeader: [
    "desktopHeader",
    "wrapper",
    "logo",
    "navWrapper",
    "nav",
    "features",
    "actions",
    "logInButton",
    "requestDemoButton"
  ],
  wrapper: [
    "wrapper",
    "logo",
    "navWrapper",
    "nav",
    "features",
    "actions",
    "logInButton",
    "requestDemoButton"
  ],
  logo: ["logo"],
  navWrapper: ["navWrapper", "nav", "features"],
  nav: ["nav", "features"],
  features: ["features"],
  actions: ["actions", "logInButton", "requestDemoButton"],
  logInButton: ["logInButton"],
  requestDemoButton: ["requestDemoButton"],
  mobileHeader2: [
    "mobileHeader2",
    "logo3",
    "right2",
    "logInLink",
    "divider",
    "mobileDrawer",
    "button",
    "hamburgerIcon",
    "body",
    "menu",
    "mobileDrawerItem",
    "bottom",
    "actions2",
    "requestDemoButton2",
    "logInButton2",
    "socials",
    "x",
    "fb",
    "ig",
    "li",
    "th"
  ],
  logo3: ["logo3"],
  right2: [
    "right2",
    "logInLink",
    "divider",
    "mobileDrawer",
    "button",
    "hamburgerIcon",
    "body",
    "menu",
    "mobileDrawerItem",
    "bottom",
    "actions2",
    "requestDemoButton2",
    "logInButton2",
    "socials",
    "x",
    "fb",
    "ig",
    "li",
    "th"
  ],
  logInLink: ["logInLink"],
  divider: ["divider"],
  mobileDrawer: [
    "mobileDrawer",
    "button",
    "hamburgerIcon",
    "body",
    "menu",
    "mobileDrawerItem",
    "bottom",
    "actions2",
    "requestDemoButton2",
    "logInButton2",
    "socials",
    "x",
    "fb",
    "ig",
    "li",
    "th"
  ],
  button: ["button", "hamburgerIcon"],
  hamburgerIcon: ["hamburgerIcon"],
  body: [
    "body",
    "menu",
    "mobileDrawerItem",
    "bottom",
    "actions2",
    "requestDemoButton2",
    "logInButton2",
    "socials",
    "x",
    "fb",
    "ig",
    "li",
    "th"
  ],
  menu: ["menu", "mobileDrawerItem"],
  mobileDrawerItem: ["mobileDrawerItem"],
  bottom: [
    "bottom",
    "actions2",
    "requestDemoButton2",
    "logInButton2",
    "socials",
    "x",
    "fb",
    "ig",
    "li",
    "th"
  ],
  actions2: ["actions2", "requestDemoButton2", "logInButton2"],
  requestDemoButton2: ["requestDemoButton2"],
  logInButton2: ["logInButton2"],
  socials: ["socials", "x", "fb", "ig", "li", "th"],
  x: ["x"],
  fb: ["fb"],
  ig: ["ig"],
  li: ["li"],
  th: ["th"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "header";
  desktopHeader: "div";
  wrapper: "div";
  logo: "a";
  navWrapper: "div";
  nav: "nav";
  features: typeof HeaderMenuItem;
  actions: "div";
  logInButton: typeof Button;
  requestDemoButton: typeof Button;
  mobileHeader2: "div";
  logo3: "a";
  right2: "div";
  logInLink: "a";
  divider: "div";
  mobileDrawer: typeof MobileDrawer;
  button: "button";
  hamburgerIcon: "svg";
  body: "div";
  menu: "nav";
  mobileDrawerItem: typeof MobileDrawerItem;
  bottom: "div";
  actions2: "div";
  requestDemoButton2: typeof Button;
  logInButton2: typeof Button;
  socials: "div";
  x: "a";
  fb: "a";
  ig: "a";
  li: "a";
  th: "a";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHeader__VariantsArgs;
    args?: PlasmicHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHeader__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHeader__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHeader__ArgProps,
          internalVariantPropNames: PlasmicHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHeader";
  } else {
    func.displayName = `PlasmicHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicHeader = Object.assign(
  // Top-level PlasmicHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    desktopHeader: makeNodeComponent("desktopHeader"),
    wrapper: makeNodeComponent("wrapper"),
    logo: makeNodeComponent("logo"),
    navWrapper: makeNodeComponent("navWrapper"),
    nav: makeNodeComponent("nav"),
    features: makeNodeComponent("features"),
    actions: makeNodeComponent("actions"),
    logInButton: makeNodeComponent("logInButton"),
    requestDemoButton: makeNodeComponent("requestDemoButton"),
    mobileHeader2: makeNodeComponent("mobileHeader2"),
    logo3: makeNodeComponent("logo3"),
    right2: makeNodeComponent("right2"),
    logInLink: makeNodeComponent("logInLink"),
    divider: makeNodeComponent("divider"),
    mobileDrawer: makeNodeComponent("mobileDrawer"),
    button: makeNodeComponent("button"),
    hamburgerIcon: makeNodeComponent("hamburgerIcon"),
    body: makeNodeComponent("body"),
    menu: makeNodeComponent("menu"),
    mobileDrawerItem: makeNodeComponent("mobileDrawerItem"),
    bottom: makeNodeComponent("bottom"),
    actions2: makeNodeComponent("actions2"),
    requestDemoButton2: makeNodeComponent("requestDemoButton2"),
    logInButton2: makeNodeComponent("logInButton2"),
    socials: makeNodeComponent("socials"),
    x: makeNodeComponent("x"),
    fb: makeNodeComponent("fb"),
    ig: makeNodeComponent("ig"),
    li: makeNodeComponent("li"),
    th: makeNodeComponent("th"),

    // Metadata about props expected for PlasmicHeader
    internalVariantProps: PlasmicHeader__VariantProps,
    internalArgProps: PlasmicHeader__ArgProps
  }
);

export default PlasmicHeader;
/* prettier-ignore-end */
